export function initDrawerMenu() {
  const drawer = document.getElementById('nav-drawer');
  const content = document.getElementById('nav-content');
  const buttons = [...document.querySelectorAll('.c-button__nav-switch')];
  if (!drawer || !content || !buttons.length || drawer.dataset.drawerInitialized) return;
  drawer.dataset.drawerInitialized = 'true';
  drawer.removeAttribute('aria-hidden');
  const overlay = document.createElement('div');
  overlay.className = 'drawer-overlay';
  document.body.appendChild(overlay);
  let trigger = buttons[0];
  const focusable = () => [
    ...content.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ),
  ];
  const setOpen = (open, button) => {
    if (button) trigger = button;
    drawer.classList.toggle('is-drawerActive', open);
    document.body.classList.toggle('drawer-open', open);
    overlay.classList.toggle('is-active', open);
    content.inert = !open;
    content.setAttribute('aria-hidden', String(!open));
    buttons.forEach((item) => item.setAttribute('aria-expanded', String(open)));
    if (open) (focusable()[0] || trigger).focus();
    else if (trigger.isConnected) trigger.focus({ preventScroll: true });
  };
  buttons.forEach((button) => {
    button.setAttribute('aria-controls', content.id);
    button.addEventListener('click', (event) => {
      event.preventDefault();
      setOpen(!drawer.classList.contains('is-drawerActive'), button);
    });
  });
  overlay.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', (event) => {
    if (!drawer.classList.contains('is-drawerActive')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Tab') {
      const items = [...buttons, ...focusable()];
      const first = items[0];
      const last = items.at(-1);
      if (
        event.shiftKey &&
        (document.activeElement === first || !items.includes(document.activeElement))
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        (document.activeElement === last || !items.includes(document.activeElement))
      ) {
        event.preventDefault();
        first.focus();
      }
    }
  });
  content.addEventListener('click', (event) => {
    if (event.target.closest('a')) setOpen(false);
  });
  window.addEventListener('resize', () => {
    if (getComputedStyle(drawer).display === 'none' && drawer.classList.contains('is-drawerActive'))
      setOpen(false);
  });
  // Initialize state without moving keyboard focus on page load.
  content.inert = true;
  content.setAttribute('aria-hidden', 'true');
  buttons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
}
